import { PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { useSuspenseQuery } from "@tanstack/react-query";

import { getFundingApplicationStagesQueryOptions } from "../../queries/funding-application-configuration/queries";

import { MESSAGES } from "./message-definitions";
import { ApplicationOverviewNext } from "./application-overview-next";

// TODO: LEGACY REMOVE
export const ApplicationOverviewPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationStages } = useSuspenseQuery(getFundingApplicationStagesQueryOptions(customerDomain));

  return (
    <PrimarySecondaryPage
      title={intl.formatMessage(MESSAGES.applicationOverviewTitle)}
      primaryContent={<ApplicationOverviewNext fundingApplicationStages={fundingApplicationStages} />}
    />
  );
};
